import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { H5 } from 'components/Typography';

import {
  mediaQueryMobileMin,
  mediaQueryMobileLargeMin,
  mediaQueryTabletMin,
  colorGrayDark,
  fontFamilySecondary,
  colorAccent,
} from 'styles';

export const HeaderFilters = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
`;

export const Title = styled.h1`
  font-family: ${fontFamilySecondary};
  font-size: 24px;
  line-height: 28px;
  font-weight: 700;
  color: ${colorGrayDark};

  width: 100%;
  margin: 0 8px 24px 0;

  @media ${mediaQueryMobileMin} {
    display: inline-flex;
    width: unset;
  }

  @media ${mediaQueryMobileLargeMin} {
    display: flex;
    width: 100%;
    font-size: 30px;
    line-height: 36px;
  }

  &[data-type='landing'] {
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 8px;

    @media ${mediaQueryMobileLargeMin} {
      font-size: 16px;
      line-height: 20px;
    }
  }
`;

export const ConverterWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 16px;

  @media ${mediaQueryTabletMin} {
    flex-direction: row;
    align-items: center;
  }
`;

export const ConverterInputWrapper = styled.div`
  position: relative;
  flex: 1;

  &:first-child {
    margin-bottom: -1px;
  }

  @media ${mediaQueryTabletMin} {
    &:first-child {
      margin-right: 32px;
      margin-bottom: 0;
    }
  }
`;

export const MobileSelectWrapper = styled.div`
  display: flex;
  width: 100%;

  @media ${mediaQueryMobileLargeMin} {
    display: none;
  }
`;

export const DesktopSelectWrapper = styled.div`
  display: none;

  @media ${mediaQueryMobileLargeMin} {
    display: inline-flex;
    margin-right: 16px;
  }
`;

export const DataPickerWrapper = styled.div`
  margin-right: auto;
`;

export const SelectLabel = styled.span`
  font-size: 12px;
  line-height: 16px;
`;

export const AlertTitle = styled(H5)`
  margin-bottom: 4px;
`;

export const TopDescription = styled.div`
  font-size: 14px;
  line-height: 16px;
  margin-bottom: 16px;
`;

export const BottomDescription = styled.div`
  font-size: 14px;
  line-height: 18px;
  margin-bottom: 16px;
`;

export const Line = styled.hr`
  border: 0;
  border-top: 1px solid #e5eaf3;
  margin-bottom: 16px;
  margin-top: 24px;
`;

export const ReversedLink = styled(Link)`
  order: 1;
  margin-bottom: 16px;
  font-size: 12px;
  color: ${colorAccent};
`;
